"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _popover = _interopRequireDefault(require("../popover"));
var _calendar = _interopRequireDefault(require("../calendar"));
var _button = _interopRequireDefault(require("../button"));
var _modal = _interopRequireDefault(require("../modal"));
var _ModalFooter = _interopRequireDefault(require("../modal/ModalFooter"));
var _ModalBody = _interopRequireDefault(require("../modal/ModalBody"));
const DatePicker = _ref => {
  let {
    value,
    minDate,
    maxDate,
    className,
    anchorEl,
    modal,
    onChange,
    onClose
  } = _ref;
  const [internalDate, setInternalDate] = (0, _arkReact.useInternalValue)(value, new Date());
  const handleClickOutside = _react.default.useCallback(() => {
    if ((0, _ark.isFunction)(onClose)) onClose();
  }, [onClose]);
  const handleCalendarSelect = _react.default.useCallback((newDate, event) => {
    setInternalDate(newDate);
    if ((0, _ark.isFunction)(onChange)) onChange(newDate, event);
  }, [setInternalDate, onChange]);
  const handleModalCalendarSelect = _react.default.useCallback((newDate, event) => {
    setInternalDate(newDate);
  }, [setInternalDate]);
  const handleModalOkClick = _react.default.useCallback(event => {
    if ((0, _ark.isFunction)(onChange)) onChange(internalDate, event);
  }, [onChange, internalDate]);
  if (modal) {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      centered: true
    }, /*#__PURE__*/_react.default.createElement(_ModalBody.default, null, /*#__PURE__*/_react.default.createElement(_calendar.default, {
      className: "datepicker datepicker-modal",
      date: internalDate,
      minDate: minDate,
      maxDate: maxDate,
      onSelect: handleModalCalendarSelect
    })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: "contained",
      color: "secondary",
      size: "lg",
      className: "datepicker-btn",
      onClick: handleClickOutside
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: "contained",
      color: "primary",
      size: "lg",
      className: "datepicker-btn",
      onClick: handleModalOkClick
    }, "Ok")));
  }
  return /*#__PURE__*/_react.default.createElement(_popover.default, {
    anchorEl: anchorEl,
    position: 'bottom-left',
    overflow: false,
    flexible: false,
    onClickOutside: handleClickOutside
  }, /*#__PURE__*/_react.default.createElement(_calendar.default, {
    className: "datepicker datepicker-spacing",
    date: internalDate,
    onSelect: handleCalendarSelect
  }));
  // const [isOpen, setIsOpen] = useState(false);
  // const trigger = useMemo(
  //     () => childrenToReactElement(children)
  //         .filter(child => child.type === DatePickerTrigger)
  //         .take(1)
  //         .map(child => cloneElement(child, { onTrigger: () => setIsOpen(true) }))
  //     , [children, setIsOpen]
  // );

  // const selectDate = useCallback(date => {
  //     if (isFunction(onSelect)) onSelect(date);
  // }, [onSelect]);

  // useFirstEffect(() => {
  //     if (trigger.length === 0) {
  //         console.error(new Error(`Warning: prop 'children' expected at \
  //         least one DatePickerTrigger supplied to ${DatePicker.name}`));
  //     }
  // }, trigger);

  // return (
  //     <div id="datePicker">
  //         {trigger}
  //         {isOpen && (
  //             <PopMenu
  //                 anchorEl="datePicker"
  //                 onClose={() => setIsOpen(false)}
  //                 className={className}
  //             >
  //                 <Calendar
  //                     date={value}
  //                     onSelect={date => {
  //                         selectDate(date);
  //                         setIsOpen(false);
  //                     }}
  //                     minDate={minDate}
  //                     maxDate={maxDate}
  //                 />
  //             </PopMenu>
  //         )}
  //     </div>
  // );
};
process.env.NODE_ENV !== "production" ? DatePicker.propTypes = {
  value: _propTypes.default.instanceOf(Date),
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  className: _propTypes.default.string,
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.instanceOf(HTMLElement).isRequired, _propTypes.default.shape({
    current: _propTypes.default.instanceOf(HTMLElement).isRequired
  }).isRequired]),
  modal: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClose: _propTypes.default.func
} : void 0;
DatePicker.defaultProps = {
  value: undefined,
  minDate: undefined,
  maxDate: undefined,
  className: undefined,
  anchorEl: undefined,
  modal: undefined,
  onChange: undefined,
  onClose: undefined
};
var _default = exports.default = DatePicker;